import { useState, useEffect } from 'react';
import axios from 'axios';
import { selectAuthRoutesList } from '../../../../pages/configuration/routeSlice';
import { useSelector } from 'react-redux';
import {
  useGetParticipantEmployeeDetails,
  useWealthlaneCustomerApi,
  // useWealthlaneAwardApi,
  // useGetMyHoldingOverview,
} from '../../../../hooks';
import { json } from 'stream/consumers';
import { selectTenantId } from '../../../../pages/configuration/participantSignupSlice';
import {marked} from 'marked'
import DOMPurify from 'dompurify';

interface ChatMessage {
  sender: string;
  message: string;
}

interface ChatAPIResponse {
  messages: { content: string }[];
  transcript?: string;
}

const GENERIC_ERROR_MESSAGE = 'An error occurred. Please try again later.';

const convertBlobToBase64 = (blob: Blob): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      if (reader.result) {
        resolve((reader.result as string).split(',')[1]); // Extract Base64
      } else {
        reject(new Error('FileReader failed to read the Blob.'));
      }
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
  
  const useChat = (sessionId: string) => {
  const { handleRequest } = useWealthlaneCustomerApi();
  const [chatHistory, setChatHistory] = useState<ChatMessage[]>([]);
  const [loading, setLoading] = useState(false);
  const tenantId = useSelector(selectTenantId);


  const loggedInUser = useSelector(selectAuthRoutesList);
  const { data: participantDetails } = useGetParticipantEmployeeDetails(handleRequest);

  // const { handleRequest: handleRequestAward } = useWealthlaneAwardApi();
  // const { data: portfolioData, isLoading: isPortfolioLoading } = useGetMyHoldingOverview(
  //   handleRequestAward,
  //   Boolean(loggedInUser?.currentUser?.id)
  // );

  // Log portfolio data when it changes
  // useEffect(() => {
  //   if (portfolioData) {
  //     // console.log('Portfolio Data:', JSON.stringify(portfolioData, null, 2)); // Pretty-print JSON
  //   }
  // }, [portfolioData]);

  
  const sendRequestToAPI = async (payload: object, token: string) => {
    console.log("FROM send request to api " + token)
    const headers = {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${token}`,  // Standard header name, proper template literal
        'x-api-key': process.env.REACT_APP_CHAT_X_API_KEY!,
        'x-user-id': tenantId as string,
        'x-customer-name': participantDetails?.currentWorkAddress?.companyName ?? '',
        'x-session-id': sessionId,
        'x-source': 'participant',
    };
    
    // Include sanitized portfolioData in the payload
    const requestBody = {
        ...payload,
        // portfolioData: portfolioData, // Add sanitized portfolio data to the body
    };

    try {
        const response = await axios.post(process.env.REACT_APP_CHAT_URL!, requestBody, { headers });
        return response.data;
    } catch (error) {
        console.error('Error sending request to API:', error);
        throw error;
    }
};


const fetchChatResponse = async (inputText: string, token: string) => {
  setLoading(true);
  setChatHistory((prev) => [...prev, { sender: 'You', message: inputText }]);
  console.log("PAYLOAD FROM CHAT RESPONSE: " + inputText);
  const usePersonalData = "Y";
  try {
    // Pass inputText as payload
    const payload = { inputText, usePersonalData };
    const data = await sendRequestToAPI(payload, token);
    console.log("API RESPONSE", data);

    // Extract the first message content from the API response
    let firstMessageContent = data.message;
    console.log("RAW RESPONS: " + firstMessageContent);


    // Convert markdown to HTML
    const rawHTML = await marked(firstMessageContent); // Convert markdown to HTML



    const sanitizedHTML = DOMPurify.sanitize(rawHTML, {
      ADD_TAGS: ['Link'], // Allow <Link> tags
      ADD_ATTR: ['to'], // Allow the `to` attribute
    });

    console.log("AFTER " + sanitizedHTML);
    // Update chat history with the sanitized HTML
    setChatHistory((prev) => [
      ...prev,
      { sender: 'Wealthlane', message: sanitizedHTML },
    ]);
  } catch (error) {
    console.error('Error fetching text chat response:', error);
    setChatHistory((prev) => [
      ...prev,
      { sender: 'Wealthlane', message: GENERIC_ERROR_MESSAGE },
    ]);
  } finally {
    setLoading(false);
  }
};
  const fetchAudioChatResponse = async (inputAudio: Blob, token: string) => {
    setLoading(true);

    try {
      const audioBase64 = await convertBlobToBase64(inputAudio);

      // Prepare the payload
      const payload = { action: 'sendVoice', audioBytes: audioBase64 };

      // Send request to API
      const data = await sendRequestToAPI(payload, token);

      console.log('Audio processing complete:', data);

      let transcript = data.transcript || 'Audio transcript not available';
      try {
        transcript = JSON.parse(transcript);
      } catch (error) {
        transcript = transcript;
      }
      setChatHistory((prev) => [...prev, { sender: 'You', message: transcript }]);

      let wealthlaneResponse = data.message || 'Error getting response.';

      // Parsing response content
 
      // Update chat history with transcript and Wealthlane response
      setChatHistory((prev) => [
        ...prev,
        { sender: 'Wealthlane', message: wealthlaneResponse },
      ]);
    } catch (error) {
      console.error('Error fetching audio chat response:', error);
      setChatHistory((prev) => [...prev, { sender: 'Wealthlane', message: GENERIC_ERROR_MESSAGE }]);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    chatHistory,
    setChatHistory,
    fetchChatResponse,
    fetchAudioChatResponse,
  };
};

export default useChat;
